import { createNgReactBridgeController } from '../../react-bridge'
import { JenkinsIntegrationCtrl } from './jenkins-controller'

createNgReactBridgeController('JenkinsIntegrationCtrl', JenkinsIntegrationCtrl)
